import { useEffect, useState } from 'react';

import type { SponsorshipPlacement, SponsorshipResponse } from '../types';

export function SponsoredSlot({ slot, compact = false }: { slot: string; compact?: boolean }) {
  const [placement, setPlacement] = useState<SponsorshipPlacement | null>(null);
  const [country, setCountry] = useState<string>('');

  useEffect(() => {
    let active = true;
    void fetch(`/api/v1/sponsorships/placements?slots=${encodeURIComponent(slot)}`, {
      headers: { Accept: 'application/json' },
      cache: 'no-store',
    })
      .then((response) => (response.ok ? response.json() : null))
      .then((body: SponsorshipResponse | null) => {
        if (!active || !body) return;
        setCountry(body.country);
        setPlacement(body.placements[0] ?? null);
      });
    return () => {
      active = false;
    };
  }, [slot]);

  if (!placement) return null;
  if (!placement.campaignId || !placement.sponsor) {
    return (
      <div className={`sponsor-slot sponsor-slot-empty ${compact ? 'sponsor-slot-compact' : ''}`}>
        <span>Espacio de patrocinio</span>
        <strong>Disponible {country && country !== 'ZZ' ? `en ${country}` : ''}</strong>
      </div>
    );
  }

  return (
    <aside
      className={`sponsor-slot ${compact ? 'sponsor-slot-compact' : ''}`}
      aria-label={`${placement.label} ${placement.sponsor.name}`}
    >
      {placement.sponsor.logoUrl && (
        <img src={placement.sponsor.logoUrl} alt="" loading="lazy" referrerPolicy="no-referrer" />
      )}
      <div>
        <span>{placement.label}</span>
        <strong>{placement.sponsor.name}</strong>
      </div>
      <a href={placement.clickUrl} target="_blank" rel="noopener noreferrer sponsored">
        {placement.ctaLabel}
      </a>
    </aside>
  );
}
